import { render, staticRenderFns } from "./Documents.vue?vue&type=template&id=db4c1164&scoped=true&"
import script from "@/views/Documents/Documents.ts?vue&type=script&lang=ts&"
export * from "@/views/Documents/Documents.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Documents/documents.scss?vue&type=style&index=0&id=db4c1164&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db4c1164",
  null
  
)

export default component.exports